import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { UX2 } from '@wsb/guac-widget-core';
import {
  OlsConfigStore,
  RouteHandler
} from '@wsb/guac-widget-shared/lib/common/ols-core/core-bundle';

import CategoryLink from './CategoryLink';
import styles from './styles';

const containerStyles = ({ separator, level }) => ({
  ...styles.linkContainer,
  ...(separator ? styles.separator : {}),
  ...(level > 1 ? {} : styles.bottom),
  ...(level > 2 ? styles.tighter : {})
});

function CategoriesMobile(props) {
  const { taxons } = props;

  return taxons.map(taxon => <CategoryContainer taxon={ taxon } { ...props } />);
}

CategoriesMobile.propTypes = {
  taxons: PropTypes.array,
  routePath: PropTypes.string,
  onClick: PropTypes.func,
  selectedTaxonPermalink: PropTypes.string,
  nested: PropTypes.bool,
  separator: PropTypes.bool,
  level: PropTypes.number
};

export default CategoriesMobile;

function CategoryContainer(props) {
  const {
    Element: { Block, Details, Icon }
  } = UX2;
  const {
    taxon,
    routePath,
    onClick,
    selectedTaxonPermalink,
    level = 1,
    separator = false,
    nested
  } = props;

  const { position: allProductsIndex = 0 } = OlsConfigStore.getAllProductsInfo() || {};
  const defaultCategory = OlsConfigStore.getDefaultCategory();
  const shouldHighlightDefault =
    allProductsIndex !== 0 && routePath === RouteHandler.PRODUCTS_ROUTE && !selectedTaxonPermalink;

  const isSelected = taxon.permalink === selectedTaxonPermalink;
  const isHighlightDefault = shouldHighlightDefault && taxon.permalink === defaultCategory;
  const isActive = isSelected || isHighlightDefault;
  const hasSubCategories = taxon.taxons.length > 0;
  const [isCollapsed, setIsCollapsed] = useState(true);
  const toggle = () => setIsCollapsed(prev => !prev);

  return (
    <Block key={ taxon.id } style={ containerStyles({ separator, level }) }>
      <Block style={ styles.titleContainer }>
        <Details style={ styles.title }>
          <CategoryLink
            name={ taxon.name }
            permalink={ taxon.permalink }
            isSelected={ isActive }
            onClick={ onClick }
            lighter={ level > 1 && !isActive }
            overflowHidden
          />
        </Details>
        { hasSubCategories && (
          <Block
            style={ styles.icon }
            tag='span'
            onClick={ toggle }
            children={ <Icon icon={ `${isCollapsed ? 'plus' : 'minus'}` } size='small' /> }
          />
        ) }
      </Block>
      { hasSubCategories && (
        <Block style={ isCollapsed ? styles.content : { ...styles.content, ...styles.contentOpen } }>
          <CategoriesMobile
            taxons={ taxon.taxons }
            level={ level + 1 }
            separator={ false }
            routePath={ routePath }
            onClick={ onClick }
            selectedTaxonPermalink={ selectedTaxonPermalink }
            nested={ nested }
          />
        </Block>
      ) }
    </Block>
  );
}

CategoryContainer.propTypes = {
  taxon: PropTypes.object,
  routePath: PropTypes.string,
  onClick: PropTypes.func,
  selectedTaxonPermalink: PropTypes.string,
  nested: PropTypes.bool,
  separator: PropTypes.bool,
  level: PropTypes.number
};
